module.exports = __webpack_public_path__ + "img/INNBeauty1.d47308de.jpg";